/**
 * src/data/fundImages.js — ảnh chia sẻ cho từng trang nguồn vốn.
 *
 * Ảnh do design/thuat-ngu/nguon-von-og.js sinh từ chính dữ liệu trong danh mục:
 * tên đơn vị bằng chữ, bốn ô tiêu chí, và dòng ghi rõ thông tin là tổng hợp từ
 * nguồn công khai. KHÔNG dùng logo của đơn vị: fundraising.vn không có quan hệ
 * hợp tác với họ, nên không đặt hai thương hiệu cạnh nhau.
 * Sinh lại sau khi cập nhật danh mục để ảnh luôn khớp dữ liệu.
 */
export const CO_ANH_QUY = new Set([
  '2080-ventures',
  '500-global-vietnam',
  'aiviet-venture',
  'angelcentral-vietnam',
  'antler-vietnam',
  'ascend-vietnam-ventures',
  'b-capital-early',
  'b-capital-growth',
  'beacon-fund',
  'beenext',
  'cocoon-capital',
  'cyberagent-capital',
  'do-ventures',
  'east-ventures',
  'febe-ventures',
  'genai-fund',
  'genesia-ventures',
  'golden-gate-ventures',
  'hcm-vif',
  'insignia-ventures-partners',
  'iterative',
  'january-capital',
  'jenfi',
  'kk-fund',
  'mekong-capital',
  'monks-hill-ventures',
  'mynavi',
  'patamar-capital',
  'quest-ventures',
  'smedf',
  'theventures',
  'thinkzone-global-minds-fund-i',
  'tin-men-capital',
  'touchstone-partners',
  'tvs-chung-khoan-thien-viet',
  'vertex-ventures-seai',
  'vic-partners',
  'vinventures',
  'vsv-capital',
]);

/** Ảnh chia sẻ Facebook/Zalo (1200×630, JPEG). */
export const anhChiaSeQuy = (slug) => (CO_ANH_QUY.has(slug) ? `/og/nguon-von/${slug}.jpg` : '');
